import React from 'react'
import { colors } from '../../__styling/settings/colors'

export interface TheWestMarkProps {
    className?: string
    fill?: string
    width?: number
    height?: number
}

export const TheWestMark: React.FC<TheWestMarkProps> = (props) => (
    <svg
        width={props.width ?? 74}
        height={props.height ?? 65}
        viewBox="0 0 220 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.className}
    >
        <title>The West Australian</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M195.381 21.0183L203.632 12.89L205.647 14.6461L195.474 24.8077L195.154 103.201L208.946 117.059L217.013 108.975L219.032 110.73L190.753 139.144L168.341 116.508C150.056 145.331 107.572 143.485 88.3251 120.432C68.7548 144.965 29.5712 142.147 11.2384 120.295L7.93861 116.044C-10.4371 91.3768 3.17086 62.4124 47.9031 25.9618C32.5498 25.9617 25.9503 21.2027 16.3253 21.2027C10.2303 21.2028 5.60396 23.0965 5.60382 27.5791C5.60382 32.4283 8.07527 33.5387 17.1031 36.7268C5.42001 36.6797 0.101533 31.8737 0.148133 21.4829C0.148133 10.0254 10.0471 2.31087 24.0728 2.35802C36.1229 2.35807 45.3814 7.43866 56.3341 8.50134C63.667 9.19386 70.7695 3.88064 74.1625 0.460507L74.0252 93.9156L47.856 117.386L47.9932 28.8746C17.9308 55.3911 16.2793 84.7255 30.6251 104.173C43.1826 121.172 66.4155 124.774 84.9782 116.324C66.5988 91.6062 80.1211 62.5498 124.85 26.0991C109.497 26.0991 102.897 21.3414 93.272 21.3414C87.1337 21.298 82.5505 23.2386 82.5505 27.7178C82.5508 32.5663 85.0257 33.6764 94.0526 36.8641C82.3662 36.8168 77.0949 32.0148 77.0949 21.6202C77.0949 10.1628 86.9507 2.44819 101.019 2.49534C113.026 2.49539 122.374 7.57725 133.327 8.64005C140.66 9.3328 147.767 4.01856 151.156 0.601988V23.9311L174.576 0L195.381 21.0183ZM148.418 28.0868L148.328 94.0544L122.112 117.524L122.249 29.0119C92.1863 55.5284 90.535 84.8156 104.881 104.31C118.86 123.203 146.174 125.698 165.377 113.272L165.33 33.3063L154.33 22.2181L148.418 28.0868Z"
            fill={props.fill ? props.fill : colors.black}
        />
    </svg>
)
TheWestMark.displayName = 'TheWestMark'
